/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Dictate_ErrorInputs */



/**
* | output |
* | --- |
* | "Transcription failed. Please try again." |
*
* @param {Chat_Dictate_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_dictate_error = /** @type {((inputs?: Chat_Dictate_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Dictate_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Transkription ist fehlgeschlagen. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Transcription failed. Please try again.")
});